<template>
  <div class="links" :class="{mobile: isMobile}">
    <router-link :to="`/list?walking=true`">Near the venue</router-link>
    <router-link :to="`/list?bestValue=true`">Best value</router-link>
    <router-link :to="`/list?city=true`">City Center</router-link>
    <router-link :to="`/list`" @click.native="$emit('clickOnShowAllHotels')">See all hotels</router-link>
  </div>
</template>

<script>
export default {
  props: {
    isMobile: Boolean
  }
}

</script>

<style lang="scss" scoped>
.links {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  padding-left: 60px;
  height: 100%;
  a {
    flex: 0 0 auto;
    color: gray;
    text-decoration: none;
    line-height: 100%;
    display: inline-block;
    position: relative;
    line-height: 60px;
    font-weight: bold;
    margin: 0 10px;
    font-size: 16px;
    &:after {
    content: '';
      display: block;
      margin: auto;
      height: 2px;
      width: 0px;
      background: transparent;
      transition: width .5s ease, background-color .5s ease;
    }
    &:hover:after {
      width: 100%;
      background: gray;
    }
    &.router-link-exact-active {
      color: $secondary-black;
    }
  }
}

.mobile a {
  line-height: 77px;
}
.selected {
  color: $primary-black !important;
  &:after {
    width: 100% !important;
    background: $primary-black !important;
  }
}
</style>
